import React from 'react';
import { Drawer } from '@dsg-tech/homefield-react';
import { HomefieldIconSignCancel } from '@dsg-tech/homefield-react-icons';
import { NEW_KEY_CODES } from 'utility/constants';
import SignedOutState from './SignedOutState/SignedOutState';
import './MyAccountDrawer.scss';

interface MyAccountDrawerProps {
  headerRef: HTMLElement | null;
  showDrawer: boolean;
  setShowDrawer: () => void;
  closing: boolean;
  viewPortBreakpoint: string;
}

const MyAccountDrawer = ({
  headerRef,
  showDrawer,
  setShowDrawer,
  closing,
  viewPortBreakpoint,
}: MyAccountDrawerProps) => {
  return (
    <Drawer
      className="myaccount-drawer-container"
      id="myAccountDrawerContainer"
      anchorElement={viewPortBreakpoint === 'mobile' ? null : headerRef?.current}
      attachedBackground={viewPortBreakpoint !== 'mobile'}
      open={showDrawer}
      closing={closing}
      closable={false}
      onCloseModal={() => setShowDrawer()}
      direction={viewPortBreakpoint === 'mobile' ? 'bottom' : 'right'}>
      <div className="my-account-drawer-content-container">
        <div className="my-account-drawer-header hmf-display-flex hmf-flex-row hmf-justify-content-between hmf-pt-m hmf-pb-xs hmf-px-m hmf-align-items-center">
          <span className="hmf-header-bold-s">My Account</span>
          <button
            className="close-icon-container hmf-p-xxs"
            type="button"
            aria-label="Close menu"
            onClick={() => setShowDrawer()}
            onKeyDown={(event) => {
              if (event.key === ' ' || event.key === NEW_KEY_CODES.ENTER) {
                setShowDrawer();
              }
            }}
            tabIndex={0}>
            <HomefieldIconSignCancel width="24" height="24" />
          </button>
        </div>
        <div className="my-account-drawer-body">
          <SignedOutState />
        </div>
      </div>
    </Drawer>
  );
};

export default MyAccountDrawer;
